module.exports = __webpack_public_path__ + "img/dah.7b9c8f38.png";